import { render, staticRenderFns } from "./readComment.vue?vue&type=template&id=e8ab2468&scoped=true&"
import script from "./readComment.vue?vue&type=script&lang=js&"
export * from "./readComment.vue?vue&type=script&lang=js&"
import style0 from "./readComment.vue?vue&type=style&index=0&id=e8ab2468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab2468",
  null
  
)

export default component.exports